/* eslint-disable */
/* TODO: 2026-05-06 очень много ненужного, надо поудалять (скопировали как есть из rtms-frontend) ! */
import { formatISO, parseISO } from 'date-fns'
import { formatQuarterFromDate } from '@/lib/dateInput.js'
import { ru } from 'date-fns/locale'
import { pick as _pick, pickBy as _pickBy, result as _result, set as _set } from 'lodash-es'
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz'
import conf from '@/config'

const tz = conf.VITE_TIMEZONE || 'Europe/Moscow'

const numberFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})
const numberFormatterFractions = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function transformer(spec) {
  const pick = []
  const tfs = {}
  for (let sp of spec) {
    let key = sp
    let tf
    if (Array.isArray(sp)) {
      key = sp[0]
      tf = sp[1]
    }

    pick.push(key)

    if (tf instanceof Function) {
      tfs[key] = tf
    } else {
      if (tf === undefined) {
        tf = 'pipe'
      }
      // string w/ tf name
      tfs[key] = commons[tf]
    }
  }

  return data => {
    /*
      TODO: multiple arrays in the same path string

      ex: some.value.[].inner.some.[].val.u
      {
        some:{
          value:[
            {
              inner:{
                some:[
                  {
                    val:{
                      u: <VALUE>
                    }
                  }
                ]
              }
            }
          ]
        }
      }

    */

    const _d = _pick(data, pick)
    for (const [k, tf] of Object.entries(tfs)) {
      const ka = k.split('.')
      let ai = ka.indexOf('[]')

      if (ai !== -1) {
        const ak0 = ka.slice(0, ai).join('.')
        ai++
        const ak1 = ka.slice(ai, ka.length).join('.')
        const ar1 = _result(_d, ak0)
        let a1 = ar1.map(ae => tf(_result(ae, ak1)))
        _set(_d, ak0, a1)
      } else {
        _set(_d, k, tf(_result(_d, k)))
      }
    }
    return _d
  }
}

/**
 * Склеивает подписи элементов списка через ", ".
 * Некорректное скалярное значение из API считает пустым списком.
 *
 * @param {Array|undefined|null} list - Исходные элементы.
 * @param {Function} pick - Функция получения подписи.
 * @param {Function} [expand] - Функция раскрытия вложенного списка.
 * @returns {string} строка непустых подписей.
 */
export function joinLabels(list, pick, expand) {
  const source = Array.isArray(list) ? list : []
  const items = expand
    ? source.flatMap(item => {
        const nested = expand(item)
        return Array.isArray(nested) ? nested : []
      })
    : source
  return items.map(pick).filter(Boolean).join(', ')
}

export const commons = {
  pipe: v => v,
  skipEmpty: v => (v ? v : undefined),
  id: v => (v?.id != null && v.id !== '' ? { id: v.id } : null),
  ids: v => (Array.isArray(v) ? v.map(({ id }) => ({ id })) : []),
  date: v => {
    if (!v) return null
    const d = v instanceof Date ? v : fromZonedTime(v, tz)
    if (!d || Number.isNaN(d.getTime())) return null
    // Квартал — полдень UTC 1-го числа. Обычный день сохраняем как локальную календарную дату
    // в 00:00, иначе 01.10 в UTC+5 уезжает на 30.09 и читается как Q3.
    if (formatQuarterFromDate(d)) {
      const y = d.getUTCFullYear()
      const m = String(d.getUTCMonth() + 1).padStart(2, '0')
      const day = String(d.getUTCDate()).padStart(2, '0')
      return `${y}-${m}-${day} 12:00:00`
    }
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day} 00:00:00`
  },
  dateLocal: (dt, fmt = 'P', options = {}) => {
    if (!dt) return null
    try {
      const d = typeof dt === 'string' && dt.trim() === '' ? null : fromZonedTime(dt, tz)
      if (!d || Number.isNaN(d.getTime())) return null
      if (options.allowQuarterFormat !== false) {
        const asQuarter = formatQuarterFromDate(d)
        if (asQuarter) return asQuarter
      }
      return formatInTimeZone(d, tz, fmt, { locale: ru })
    } catch {
      return null
    }
  },
  dateTimeLocal: v => {
    return v
      ? formatInTimeZone(v instanceof Date ? v : fromZonedTime(v, tz), tz, 'dd.MM.yyyy HH:mm:ss')
      : null
  },
  deci: decimalTransformer,
  decistring: v => decimalTransformer(v).toFixed(2),
  datestring: v =>
    v
      ? formatInTimeZone(
          v instanceof Date ? v : fromZonedTime(v, tz),
          'Europe/Moscow',
          'dd.MM.yyyy'
        )
      : null,
  numberFormat: num => {
    return num % 1 == 0 ? numberFormatter.format(num) : numberFormatterFractions.format(num)
  },
  moneyFormat: num => {
    const n = Number(num)
    if (isNaN(n)) {
      return numberFormatterFractions.format(0)
    }
    return numberFormatterFractions.format(n)
  },
}

function decimalTransformer(v) {
  const n = Number(v)
  if (isNaN(n)) {
    return 0
  }
  return Math.round((n + Number.EPSILON) * 100) / 100
}

const expensePropsIdObjects = ['stock', 'replaces', 'shared_order', 'shared_order', 'aligned_by', 'edit_aligned_by', 'purchase']
const expensePropsSkip = [
  'deleted',
  'uuid',
  'has_replaces',
  'align_decline',
  '_display',
  'unblocked',
  'amountAlert',
  'available_amount',
  'reserved_amount',
  'status',
  'isAligned',
  'storage_conditions_name',
  'reserve_dissolved',
  'i',
  'edit_allowed',
]
const expensePropsSkipEmpty = [
  'sort',
  'status',
  'stock',
  'shared_order',
  'replaces',
  'purchase',
  // 'aligned',
  // 'aligned_by',
  // 'edit_aligned',
  // 'edit_aligned_by',
  'edit_alignment_requested',
  'assign_user',
  'pay_date_executed',
  'pay_date_expected',
  'test_date_executed',
  'test_date_expected',
]
const expenseTransform = transformer([
  ['pay_date_executed', 'date'],
  ['pay_date_expected', 'date'],
])
export const expenseTransformer = plname => exps =>
  !Array.isArray(exps)
    ? []
    : exps.map(exp => {
        if (!(exp.align_decline || exp.aligned)) {
          exp.aligned = null
        }

        if (exp.replaces?.id && typeof exp.replaces.id === 'string') {
          let replace_uuid = exp.replaces.id
          exp.replaces = { id: 0 }
          if (exp.is_local) {
            exp.replace_uuid = replace_uuid
          }
        }
        delete exp.is_local

        for (let i of expensePropsIdObjects) {
          if (exp[i]) {
            if ('expense_type' in exp[i])
              exp[i] = { id: exp[i].id, expense_type: exp[i].expense_type }
            else
              exp[i] = { id: exp[i].id }
          }
        }
        exp = { ...exp, ...expenseTransform(exp) }
        return {
          ..._pickBy(exp, (val, name) => {
            if (expensePropsSkip.includes(name)) {
              return false
            }
            if (expensePropsSkipEmpty.includes(name) && val === null) {
              return false
            }
            return true
          }),
          [plname]: { id: exp[plname].id },
        }
      })

const destructionPropsIdObjects = ['stock']
const destructionPropsSkip = [
  'deleted',
  'uuid',
  '_display',
  'i',
  'unique_id',
]
const destructionPropsSkipEmpty = [
  'stock',
  'sort',
]
export const destructionTransformer = plname => dests =>
  !Array.isArray(dests)
    ? []
    : dests.map(dest => {
        for (let i of destructionPropsIdObjects) {
          if (dest[i]) {
            dest[i] = { id: dest[i].id }
          }
        }
        return _pickBy(dest, (val, name) => {
          if (destructionPropsSkip.includes(name)) {
            return false
          }
          if (destructionPropsSkipEmpty.includes(name) && val === null) {
            return false
          }
          return true
        })
      })

// returns uploads
// !important: value of date-formatted should be instance of Date or ISO-date formatted string
export function transformUploads(uploads, dateKeys = []) {
  return (uploads || []).map(f => {
    const base = { id: f.id, secure_filename: f.secure_filename };

    if (!f.metadata) {
      return base;
    }
    const metadata = { ...f.metadata };

    for (let i of dateKeys) {
      if (metadata[i]) {
        metadata[i] = formatISO(metadata[i], { representation: 'date' })
      }
    }

    return { ...base, metadata };
  })
}

// returns uloads
export function pickUploads(uploads = [], dateKeys = []) {
  return (uploads || []).map(u => {
    if (!u.metadata) {
      return u
    }
    for (let i of dateKeys) {
      // wtf??? почему-то стала прилетать Data вместо строки
      if (u.metadata[i] && !(u.metadata[i] instanceof Date)) {
        u.metadata[i] = parseISO(u.metadata[i])
      }
    }
    return u
  })
}

export const listPickMapper = (prop, prefix) => item => {
  let val = listPick(item, prop, prefix)
  return { ...item, [prop]: val }
}

export function listPick(item, prop, prefix) {
  let val = _result(item, prop)
  if (!val) {
    const pfx = Array.isArray(prefix) ? prefix : String(prefix).split('.')
    val = _result(item, [...pfx, prop])
  }
  return val
}
